var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 314,
    viewBox: "0 0 317 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.578601 18.0783C0.535246 8.10667 8.60673 0 18.5784 0H174C183.941 0 192 8.05888 192 18V44.8039C192 55.8496 183.046 64.8039 172 64.8039H160.605C143.15 64.8039 129 78.9539 129 96.4089C129 106.676 120.676 115 110.409 115H18.9219C9.01133 115 0.965168 106.989 0.922079 97.0783L0.578601 18.0783Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 97,
    r: 25,
    fill: "#151521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 106.969L162.013 106.954",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.615 105.533V110.369C170.615 110.481 170.593 110.592 170.55 110.695C170.507 110.799 170.443 110.893 170.363 110.972C170.283 111.051 170.188 111.114 170.084 111.157C169.979 111.2 169.867 111.222 169.754 111.222H154.246C154.133 111.222 154.021 111.2 153.916 111.157C153.812 111.114 153.717 111.051 153.637 110.972C153.557 110.893 153.494 110.799 153.45 110.695C153.407 110.592 153.385 110.481 153.385 110.369V105.533M170.615 88.4666V83.631C170.615 83.4047 170.525 83.1877 170.363 83.0276C170.202 82.8676 169.982 82.7777 169.754 82.7777H154.246C154.018 82.7777 153.799 82.8676 153.637 83.0276C153.475 83.1877 153.385 83.4047 153.385 83.631V88.4666",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.026 92.0221L172.052 96.9999L167.026 101.978M156.975 92.0221L151.949 96.9999L156.975 101.978",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 97.5862C196.5 88.4259 203.926 81 213.086 81H297C307.493 81 316 89.5066 316 100V294C316 304.493 307.493 313 297 313H21C10.5066 313 2 304.493 2 294V151C2 140.507 10.5066 132 21 132H162.086C181.092 132 196.5 116.592 196.5 97.5862Z",
    stroke: "#C1B5FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinMobile);
export default __webpack_public_path__ + "static/media/min-mobile.055281be0512982ae0715ff84ebde04f.svg";
export { ForwardRef as ReactComponent };